<template>
  <component
    :is="embedded ? 'div' : 'el-main'"
    :style="embedded ? { overflow: 'auto' } : { height: height + 'px', overflow: 'auto' }"
    v-infinite-scroll="load"
    :infinite-scroll-disabled="disabled"
  >
    <div :class="embedded ? 'embedded-content' : 'Scroll_content'">
      <div>

        <div class="titleinder_content">
          <div class="simkeropl">{{ $t('Monthly.Monthlys') }}
            <div class="left_right_rili">
              <el-date-picker v-model="value2" type="month" :placeholder="$t('Monthly.yue')" @change="get_time" value-format="yyyy-MM">
              </el-date-picker>
            </div>
          </div>
        </div>
        <el-table :data="tableData" :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }"
          style="width: 100%">
          <el-table-column prop="datetime" :label="$t('Monthly.Date')" width="190">
          </el-table-column>
          <el-table-column prop="student" :label="$t('Monthly.studen')" width="100">
          </el-table-column>
          <el-table-column prop="class" :label="$t('Monthly.class')" width="180">
          </el-table-column>
          <el-table-column prop="class_type" :label="$t('Monthly.Class_size')" width="100">
          </el-table-column>
          <el-table-column prop="requried_credit" :label="$t('Monthly.Requried')">
          </el-table-column>
          <el-table-column prop="status" :label="$t('Monthly.Status')">
          </el-table-column>
          <el-table-column prop="status" :label="$t('Monthly.CreditType')">
            <template slot-scope="scope">
              <el-button size="mini" type="" style="cursor: default; background-color: #F3F4F6;color: #4B5563;" disabled plain v-if="scope.row.quantity_type == 2">{{ $t('Monthly.FreeCredit') }}</el-button>
              <el-button disabled size="mini" style="cursor: default; background-color: #B50604;color: #fff;border: none;" v-else>{{ $t('Monthly.PaidCredit') }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="detail" align="left" :label="$t('Monthly.Detail')">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="mg_tinmqx" v-if="is_show"> {{ $t('reached') }}</div>
  </component>

</template>
<script>
import { setStore, getStore, keys } from '@/store';
import IndexFooter from '../views/footer'
import MyScheduled from '../views/scheduled'
import MyCourse from '../views/course'
import PastLesson from '../views/lesson'

//引入header组件
import Header from '../header/header'

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IndexFooter,
    MyScheduled,
    PastLesson,
    MyCourse,
    Header
  },
  data() {
    return {
      height: 100,
      tableData: [],
      value2: '',
      totle: null,
      pagesize: 10,
      page: 1,
      month: '',
      student_sn: '',
      disabled: false,
      currentPage: 1,
      is_show: false,
    }
  },
  created() {
    if (!this.embedded) {
      let height = document.body.offsetHeight - 104;
      this.height = height
    }
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/onboarding'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
      return false
    }

  },
  computed: {

  },
  methods: {
    /**
     * 下拉滚动方法
     */
    load() {
      if (this.value2 == '') {
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        this.value2 = y + '-' + m;
      }
      let _this = this;
      let un = getStore(keys.userInfo);
      this.$http.get('/api/getLearnerSectionRecord?pagesize=' + this.pagesize + '&page=' + this.page + '&month=' + this.month + '&student_sn=' + un.last_student_sn).then((res) => {
        if (res.data.code == 200) {
          this.page = this.page + 1
          if (_this.tableData.length != res.data.data.total) {
            for (let i = 0; i < res.data.data.data_info.length; i++) {
              this.tableData.push(res.data.data.data_info[i])
            }
          } else {
            _this.is_show = true
            _this.disabled = true
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },

    get_time(val) {
      this.page = 1
      this.month = val
      this.disabled = false
      this.is_show = false
      let un = getStore(keys.userInfo);
      this.$http.get('/api/getLearnerSectionRecord?pagesize=' + this.pagesize + '&page=' + this.page + '&month=' + this.month + '&student_sn=' + un.last_student_sn).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.data_info
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  },
  mounted() {

  },
  watch: {

  },
}
</script>
<style lang="less" scoped>
.embedded-content {
  padding: 24px;
}

.simkeropl {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  color: #000000;
  margin-bottom: 30px;
}

.embedded-content .simkeropl {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}

.titleinder_content {
  width: 100%;
  border: 0px solid red;
  overflow: hidden;
}

.left_right_rili {
  float: right;
}

.mg_tinmqx {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */
  color: #A5A5A5;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/children/MonthyuStatement.vue